import { Button } from "@/components/ui/button";
import { useTechniqueChat } from "./TechniqueChatProvider";

interface QuickActionsProps {
  compact?: boolean;
}

const QUICK_PROMPTS = [
  {
    label: "Explain simpler",
    prompt: "Can you explain this technique in simpler terms?",
  },
  {
    label: "Show example",
    prompt: "Can you show me another example of this technique?",
  },
  {
    label: "Why it works",
    prompt: "Why does this technique work? What's the math behind it?",
  },
  {
    label: "Common mistakes",
    prompt: "What are common mistakes to avoid with this technique?",
  },
];

const COMPACT_PROMPTS = [
  { label: "Example", prompt: "Show me another example" },
  { label: "Simpler", prompt: "Explain that more simply" },
  { label: "Step by step", prompt: "Can you break that down step by step?" },
];

export function QuickActions({ compact = false }: QuickActionsProps) {
  const { sendMessage, isLoading } = useTechniqueChat();

  const prompts = compact ? COMPACT_PROMPTS : QUICK_PROMPTS;

  return (
    <div className={`flex flex-wrap gap-2 ${compact ? "" : "justify-center"}`}>
      {prompts.map((item) => (
        <Button
          key={item.label}
          variant="outline"
          size="sm"
          onClick={() => sendMessage(item.prompt)}
          disabled={isLoading}
          className="text-xs"
        >
          {item.label}
        </Button>
      ))}
    </div>
  );
}
